import React, { useState, Suspense, lazy, useEffect, useCallback } from "react";
//import { Router, Location, Redirect } from '@reach/router';
import { Location, Redirect } from "@reach/router";
import "./home.css";

import { Typography } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";

import { Web3ModalContext } from "../../../contexts/Web3ModalProvider";
import { Web3WrapperContext } from "contexts/Web3WrapperProvider";

import "./sidebar.scss";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { margin } from "@mui/system";

import {
  DashboardSlice,
  login,
  setNetwork,
} from "../../../store/reducers/DashboardSlice";

import { useNavigate } from "react-router-dom";
import { setDashboard } from "../../../store/reducers/DashboardSlice";

const windowUrl = window.location.search;
const params = new URLSearchParams(windowUrl);

const Home = lazy(() => import("../../pages/Home"));
const Dashboard = lazy(() => import("../../pages/Dashboard"));
const Poolboard = lazy(() => import("../../pages/Poolboard"));

function HomePage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { dashboard } = useAppSelector((state) => state.DashboardReducer);
  let GraceValue = 0;
  const [totalGraceHave, setTotalGraceHave] = useState(0);

  const { web3Wrapper: wrapper } = useContext(Web3WrapperContext);

  const { connect, disconnect, account } = useContext(Web3ModalContext);

  const { isConnectedWallet, poolId, isCurrentNetwork } = useAppSelector(
    (state) => state.DashboardReducer
  );

  const getTokenAmount = async () => {
    dispatch(setDashboard(0));
    let crace = 0;
    if (dashboard) {
      crace = dashboard.balance;
    } else {
      crace = 0;
    }
    //console.log(crace);
    setTotalGraceHave(crace);
  };

  useEffect(() => {
    getTokenAmount();
  }, [wrapper]);

  useEffect(() => {
    getTokenAmount();
  }, [GraceValue]);

  useEffect(() => {
    walletHandler();
    console.log("-------");
  }, []);

  const walletHandler = useCallback(() => {
    //  alert("web");
    
    connect();
  }, [connect]);
  React.useLayoutEffect(() => {
    if (!window["ethereum"]) {
      dispatch(DashboardSlice.actions.setMetaMaskState(false));
      return;
    }
    dispatch(DashboardSlice.actions.setMetaMaskState(true));
    window["ethereum"].on("accountsChanged", async (accounts) => {
      if (accounts.length === 0) return dispatch(DashboardSlice.actions.exit());
      fetchInfo();
    });
    window["ethereum"].on("networkChanged", function () {
      fetchInfo();
    });

    const fetchInfo = async () => {
      await dispatch(login());
      await dispatch(setNetwork());
    };
    fetchInfo();
  }, []);

  const isShowPoolboard = React.useMemo(
    () => isConnectedWallet && isCurrentNetwork,
    [isConnectedWallet, isCurrentNetwork]
  );

  const [currentState, setCurrentState] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const location = useLocation();
 // console.log(location.pathname);

  useEffect(() => {
    if (location.pathname == "/") {
      setCurrentState(0);
      setCurrentIndex(0);
      document.getElementById("unity-container").style.display = "none";
     // document.getElementById("unity-container").style.display = "block";
    } else if (location.pathname == "/game") {
      setCurrentState(1);
      setCurrentIndex(1);
      document.getElementById("unity-container").style.display = "block";
    } else if (location.pathname == "/Swap") {
      setCurrentState(0);
      setCurrentIndex(0);
      document.getElementById("unity-container").style.display = "none";
    }  else if (location.pathname == "/poolboard") {
      setCurrentState(2);
      setCurrentIndex(2);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/Mint") {
      setCurrentState(3);
      setCurrentIndex(3);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/Toxic") {
      setCurrentState(3);
      setCurrentIndex(3);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/MarketPlace") {
      setCurrentState(4);
      setCurrentIndex(4);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/AuctionDetail") {
      setCurrentState(4);
      setCurrentIndex(4);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/ItemDetail") {
      setCurrentState(4);
      setCurrentIndex(4);
      document.getElementById("unity-container").style.display = "none";
    } else if (location.pathname == "/ComingSoon") {
      setCurrentState(5);
      setCurrentIndex(5);
      document.getElementById("unity-container").style.display = "none";
    }
    console.log("---------");
  }, []);

  const PosedRouter = ({ children }) => (
    <Location>
      {({ location }) => (
        <div id="routerhang">
          <div key={location.key}>
            <Router location={location}>{children}</Router>
          </div>
        </div>
      )}
    </Location>
  );

  const ClickonNav = async (data) => {
    console.log(data);
    //  setCurrentState(data);
    //  setCurrentIndex(data);
  };

  const ClickonSocial1 = async (data) => {
    window.open('https://discord.com/invite/AqWHXP3Jk7', '_blank').focus();
  };
  const ClickonSocial2 = async (data) => {
    window.open('https://t.me/joinchat/uVEV57tKZ05hODY0', '_blank').focus();
  };
  const ClickonSocial3 = async (data) => {
    window.open('https://twitter.com/coin_racer', '_blank').focus();
  };

  return (
    <div className="sidebar">
      <div class="wrapper">
        <nav className="" id="sidebar">
          <div class="sidebar-header">
            {!account ? (
              <a
                className="navbar-brand"
                href="#!"
                id="connectWallet"
                onClick={walletHandler}
              >
                <img width="95%" src="images/ConnectWalletButton.png" />
              </a>
            ) : (
              <a className="navbar-brand connected-wallet" href="#!">
                Wallet Connected
              </a>
            )}
          </div>

          <ul class="list-unstyled components">
          <Link to="/" style={{ textDecoration: "none" }}>
              <li
                className={currentIndex === 0 ? "active" : ""}
                onClick={() => {
                  setCurrentIndex(0);
                  setCurrentState(0);
                  document.getElementById("unity-container").style.display =
                    "none";
                }}
              >
                <span>NFT Mint</span>
                {/* <span>Tournaments & Bet</span> */}
              </li>
            </Link>
            <Link to="/game" style={{ textDecoration: "none" }}>
              <li
                className={currentIndex === 1 ? "active" : ""}
                onClick={() => {
                  setCurrentIndex(1);
                  setCurrentState(1);
                  document.getElementById("unity-container").style.display =
                    "block";
                }}
              >
                <span>Play</span>
              </li>
            </Link>
            
            <Link to="/poolboard" style={{ textDecoration: "none" }}>
              <li
                className={currentIndex === 2 ? "active" : ""}
                onClick={() => {
                  setCurrentIndex(2);
                  setCurrentState(2);
                  document.getElementById("unity-container").style.display =
                    "none";
                }}
              >
                <span>Stake Crace</span>
              </li>
            </Link>

           
            <Link to="/Toxic" style={{ textDecoration: "none" }}>
              <li
                className={currentIndex === 4 ? "active" : ""}
                onClick={() => {
                  setCurrentIndex(4);
                  setCurrentState(4);
                  document.getElementById("unity-container").style.display =
                    "none";
                }}
              >
                <span>Nft Mutation</span>
              </li>
            </Link>
            <Link to="/MarketPlace" style={{ textDecoration: "none" }}>
              <li
                className={currentIndex === 5 ? "active" : ""}
                onClick={() => {
                  setCurrentIndex(5);
                  setCurrentState(5);
                  document.getElementById("unity-container").style.display =
                    "none";
                }}
              >
                <span>Nft Market Place</span>
              </li>
            </Link>
          </ul>
          <hr />

          <div
            style={{ paddingLeft: "20px", paddingRight: "30px" }}
            class="d-flex justify-content-around bottom"
          >
            {/* <li>
              <a href="https://bootstrapious.com/tutorial/files/sidebar.zip" class="download">Download source</a>
            </li>
            <li>
              <a href="https://bootstrapious.com/p/bootstrap-sidebar" class="article">Back to article</a>
            </li> */}

            <img className="curserPointer"
              width="23%"
              onClick={ClickonSocial1}
              src="./images/Social3.png"
            />
            <img className="curserPointer"
              width="23%"
              onClick={ClickonSocial2}
              src="./images/Social2.png"
            />
            <img className="curserPointer"
              width="23%"
              onClick={ClickonSocial3}
              src="./images/Social1.png"
            />
          </div>
        </nav>
      </div>
    </div>
  );
}

export default HomePage;
